import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function GProgress() {
  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <CircularProgress color="primary" style={{ margin: 'auto' }} />
    </Box>
  );
}
